import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const WaterPoloColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className="icon-freeform"
        >
            <g id="Water-Polo" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    fill="#547FFF"
                    d="M5.05 5.66 7.8 2.65l4.663-.766 3.887.766 1.135 1.153-1.336 4.039-5.094-1.767-3.493-.865z"
                />
                <path
                    fill="#547FFF"
                    d="m12 12.262 1.506 5.105 1.806-.452 3.793-3.876 2.489-5.348-1.057-2.138-2.196-2.527-1.544 3.596-2.151 3.574z"
                />
                <path
                    d="M4.252 5.914c2.773-.72 6.79-1.098 11.72 2.219-.655 1.127-1.979 2.478-3.972 4.053-1.565-1.776-4.781-1.993-9.649-.65-.012-3.096 1.1-4.415 1.901-5.622z"
                    fill="#D7FF38"
                />
                <path
                    d="M8.636 18.455c-1.186-1.888-2.144-4.242-2.392-7.027 1.288-.2 3.172-.021 5.65.536.273 2.493.868 4.294 1.786 5.403-2.442.353-3.962.095-5.044 1.088zM14.202 17.367c1.67-1.034 3.148-2.385 4.43-4.055 1.284-1.67 2.107-3.493 2.468-5.47 1.631 2.326 1.631 5.346 0 9.058-2.095 1.288-2.438 1.64-3.883 1.64-.964 0-1.969-.39-3.015-1.173z"
                    fill="#D7FF38"
                />
                <path fill="#547FFF" d="m3.672 17.5-1.321-2.75-.227-3.156 1.548-.936 2.795.327.452 5.076.881 2.48z" />
                <path
                    d="M22 19.5c.6 0 1 .4 1 1s-.4 1-1 1c-1 0-1.4.2-2 .6-.6.4-1.5.9-3 .9s-2.3-.5-3-.9c-.6-.3-1-.6-2-.6s-1.4.2-2 .6c-.6.4-1.5.9-3 .9s-2.4-.5-3-.9c-.6-.3-1-.6-2-.6-.6 0-1-.4-1-1s.4-1 1-1c1.5 0 2.3.5 3 .9.6.3 1 .6 2 .6s1.4-.3 2-.6c.6-.4 1.5-.9 3-.9s2.3.5 3 .9c.6.3 1 .6 2 .6s1.4-.2 2-.6c.6-.4 1.5-.9 3-.9zM12 1c2.1 0 4.1.6 5.8 1.6l.084.084.016.016c3.1 2 5.1 5.5 5.1 9.4 0 1.3-.2 2.7-.7 3.9.4.2.7.5.7 1 0 .6-.4 1-1 1-1 0-1.4.2-2 .6-.6.4-1.5.9-3 .9s-2.3-.5-3-.9c-.6-.3-1-.6-2-.6s-1.4.2-2 .6c-.6.4-1.5.9-3 .9s-2.3-.5-3-.9c-.6-.3-1-.6-2-.6-.6 0-1-.4-1-1 0-.5.3-.8.7-1-.4-1.2-.7-2.6-.7-3.9C1 6 5.9 1 12 1zM5.8 12c-.9 0-1.9.3-2.8.6.1 1.3.4 2.6 1 3.8.4.1.7.3 1 .5.6.3 1 .6 2 .6h.1c-.8-1.7-1.2-3.6-1.3-5.5zm15.1-1.699-.195.422c-1.206 2.518-3.031 4.672-5.305 6.377.4.2.8.4 1.6.4 1 0 1.4-.3 2.1-.6.3-.2.6-.3 1-.5.6-1.3 1-2.7 1-4.2 0-.7-.1-1.3-.2-1.9v.001zM7.8 12c.2 1.7.5 3.3 1.2 4.9.7-.4 1.5-.9 2.9-.8-.4-1-.7-2.1-.9-3.2-1-.5-2.1-.8-3.2-.9zm10.1-6.6c-.7 2.9-2.5 5.5-4.9 7.3.2 1 .5 2 .9 3 2.8-2 4.9-4.9 5.8-8.2-.5-.8-1-1.6-1.8-2.1zm-3.6 3.2c-3-1.6-6.5-2.1-9.8-1.4-.6.9-1.1 2-1.3 3.2 2.8-.8 5.9-.6 8.7.6l.38-.306A13.622 13.622 0 0 0 14.3 8.6zM12 3c-2.1 0-4 .7-5.5 1.9 3-.1 6.1.5 8.8 2 .4-.9.7-1.9.9-2.8C15 3.4 13.5 3 12 3z"
                    fill="#0C0D0E"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
};
